/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompletionList
 */
export interface CompletionList {
    /**
     * 
     * @type {boolean}
     * @memberof CompletionList
     */
    completedPhoto: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompletionList
     */
    completedExperience: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompletionList
     */
    completedDescription: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompletionList
     */
    completedSkillsOnExperience: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompletionList
     */
    completedTopSkills: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompletionList
     */
    completedCharter: boolean;
}

/**
 * Check if a given object implements the CompletionList interface.
 */
export function instanceOfCompletionList(value: object): value is CompletionList {
    if (!('completedPhoto' in value) || value['completedPhoto'] === undefined) return false;
    if (!('completedExperience' in value) || value['completedExperience'] === undefined) return false;
    if (!('completedDescription' in value) || value['completedDescription'] === undefined) return false;
    if (!('completedSkillsOnExperience' in value) || value['completedSkillsOnExperience'] === undefined) return false;
    if (!('completedTopSkills' in value) || value['completedTopSkills'] === undefined) return false;
    if (!('completedCharter' in value) || value['completedCharter'] === undefined) return false;
    return true;
}

export function CompletionListFromJSON(json: any): CompletionList {
    return CompletionListFromJSONTyped(json, false);
}

export function CompletionListFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompletionList {
    if (json == null) {
        return json;
    }
    return {
        
        'completedPhoto': json['completedPhoto'],
        'completedExperience': json['completedExperience'],
        'completedDescription': json['completedDescription'],
        'completedSkillsOnExperience': json['completedSkillsOnExperience'],
        'completedTopSkills': json['completedTopSkills'],
        'completedCharter': json['completedCharter'],
    };
}

export function CompletionListToJSON(value?: CompletionList | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'completedPhoto': value['completedPhoto'],
        'completedExperience': value['completedExperience'],
        'completedDescription': value['completedDescription'],
        'completedSkillsOnExperience': value['completedSkillsOnExperience'],
        'completedTopSkills': value['completedTopSkills'],
        'completedCharter': value['completedCharter'],
    };
}

